import { apiClient } from './client';

// ============================================================
// Types
// ============================================================

export type DocSection = {
  title: string;
  content: string;
};

export type Doc = {
  id: string;
  chatId: string;
  agentId?: string | null;
  title: string;
  subtitle?: string | null;
  sections: DocSection[];
  createdAt: string;
  updatedAt?: string;
  rawMarkdown?: string | null;
};

export type DocListItem = {
  id: string;
  chatId: string;
  agentId?: string | null;
  title: string;
  content?: string;
  createdAt: string;
  updatedAt?: string;
};

export type CreateDocPayload = {
  chatId?: string;
  agentId?: string | null;
  title: string;
  subtitle?: string | null;
  content?: string;
  rawMarkdown?: string | null;
};

export type UpdateDocPayload = {
  title?: string;
  subtitle?: string | null;
  content?: string;
  rawMarkdown?: string | null;
};

// ============================================================
// API Functions - CRUD Complete
// ============================================================

/**
 * Cria um novo documento
 */
export async function createDoc(data: CreateDocPayload): Promise<Doc> {
  return apiClient.post<Doc>('/docs', data);
}

/**
 * Busca um documento pelo ID
 */
export async function getDoc(docId: string): Promise<Doc> {
  return apiClient.get<Doc>(`/docs/${encodeURIComponent(docId)}`);
}

/**
 * Lista todos os documentos de um chat
 */
export async function listDocsByChat(chatId: string): Promise<DocListItem[]> {
  return apiClient.get<DocListItem[]>(`/docs?chatId=${encodeURIComponent(chatId)}`);
}

/**
 * Lista todos os documentos do usuário
 */
export async function listDocs(): Promise<DocListItem[]> {
  return apiClient.get<DocListItem[]>('/docs');
}

/**
 * Atualiza um documento existente
 */
export async function updateDoc(docId: string, data: UpdateDocPayload): Promise<Doc> {
  return apiClient.patch<Doc>(`/docs/${encodeURIComponent(docId)}`, data);
}

/**
 * Deleta um documento (move para lixeira ou deleta permanentemente)
 */
export async function deleteDoc(docId: string): Promise<void> {
  return apiClient.delete(`/docs/${encodeURIComponent(docId)}`);
}

/**
 * Duplica um documento existente
 */
export async function duplicateDoc(docId: string): Promise<Doc> {
  return apiClient.post<Doc>(`/docs/${encodeURIComponent(docId)}/duplicate`, {});
}

// ============================================================
// Legacy exports - Para compatibilidade com código existente
// ============================================================

/** @deprecated Use DocSection instead */
export type SpaceSection = DocSection;

/** @deprecated Use Doc instead */
export type Space = Doc;

/** @deprecated Use DocListItem instead */
export type SpaceListItem = DocListItem;

/** @deprecated Use getDoc instead */
export const getSpace = getDoc;

/** @deprecated Use listDocsByChat instead */
export const listSpacesByChat = listDocsByChat;
